/****************************************************************************************************************************
 *                                                                                                                          *
 *  TODD INITIALIZATION AND LOADER                                                                                          *
 *                                                                                                                          *
 ****************************************************************************************************************************/

/* global $shell */

/*
Chart
- screens.xsd - block definition, element definition, element in body? definition
- include/components/chart.whlib
- shell.es
- include/todd/internal/framework.witty
  add <script src="https://www.google.com/jsapi"></script>
*/

import * as dompack from 'dompack';
import { $, Element, Class, Events } from "@webhare-system/frameworks/mootools/core";
import './debugging/magicmenu';
var moo = require("@webhare-system/frameworks/mootools/core");

var Locale = require('@webhare-system/frameworks/mootools/locale');
var Browser = require("@webhare-system/compat/browser");

require('@webhare-system/compat/dragdrop');
require('@webhare-system/compat/upload');
var EventServerConnection = require('@webhare-system/net/eventserver');
var WRDAuth = require('@webhare-wrd/auth');
var WHBase = require('@webhare-system/compat/base');
var JSONRPC = require('@webhare-system/net/jsonrpc');
var MenuComponent = require('../components/basecontrols/menu');
var url = require('@webhare-system/internal/url');
var deviceinfo = require('@webhare-system/compat/deviceinfo');

require('../components/imageeditor');
var $todd = require('./support');
require('./components');
require('./dialogs');
require('./commhandler');
require('./application');
require('./desktop');
require('./apps/dashboard');
require('./login');
require('./dragdrop');
require('./upload');
//var Debug = require('./debug');
require('../css/shell.css');
require('../css/apps.css');
require('../skins/default/skin.css');
require('../skins/default/controls.css');
var Promise = require('@webhare-system/compat/promise');
var toddImages = require("./images");
var domevents = require('@webhare-system/dom/events');

var domui = require('@webhare-system/internal/legacyui');

require('@webhare-system/compat/iefocusfix'); //it'll autorun, no need to use any export
import * as domencoding from 'dompack/extra/encoding';
import TowlNotifications from './shell/towl';

var todd_components = Object.assign( {}
    //ADDME: chart, maybe rewrite to use iframe instead of being a custom component?
    , require('./codeedit').components
    , require('./containers.es').components
    , require('./fields').components
    , require('./frame').components
    , require('./iframe').components
    , require('./list').components
    , require('./panel').components
    , require('./rte').components
    , require('./table').components
    , require('./tabs').components
    //, require('./video').components
    );

var getTid = require("@webhare-tollium/gettid").getTid;
require("../common.lang.json");

"use strict";

var globalerrorcount = 0;

var WebhareConnectVersion = 1;

function getWebHareConnectURL()
{
  try
  {
    return localStorage["tollium-connecturl"] || "https://connect.webhare.com/";
  }
  catch(e)
  {
    return "https://connect.webhare.com/";
  }
}

var IndyShell = new Class(
{ Implements: [Events]

, isloggingoff: false
, istodd: false
, eventsconnection: null
, broadcaststart: null //start of broadcasts. used to filter old messages
, isloggedin: false
, checkinterval: 0
, checkcall: null
, tolliumservice: null
, checkservice: null
, offlinenotification: false
, _connectversion: 0
, _connectrequestcounter: 0
, _connectrequests: []
, _connectcapabilities: []
, wrdauth: null

, settings: {}

, initialize:function()
  {
    this.wrdauth = WRDAuth.getDefaultAuth();
    if(!WHBase.config.tollium && WHBase.config.obj)
      WHBase.config.tollium = WHBase.config.obj; //support published tollium site

    $todd.resourcebase = new url.URL(location.href).resolveToAbsoluteURL(WHBase.config.tollium.toddroot);
    this.eventsconnection = new EventServerConnection({ url: "/wh_events/"});
    this.eventsconnection.on("data", this.onBroadcastData.bind(this));
    $(window).addEvent("domready", this.onDomReady.bind(this));
    document.documentElement.addEventListener("tollium-shell:broadcast", evt => this.onBroadcast(evt));

    this.registerCustomAction("tollium:openwebhareconnect", this.openWebhareConnectInWindow.bind(this));

    //$(window).addEvent("hashchange", this.onHashChange.bind(this)); //This broke debugging, eg ?debug=1#dimensions. It needs a proper variable parser/extracter, url.URL can probably do it..
 }

  // Ability to start applications using bookmarklets
  // javascript:(function(){%20location.hash="app=blexdev_publisherreport:search"%20})();
, onHashChange:function()
  {
    var hash = window.location.hash+"";

    if (hash[0] == "#")
      hash = hash.substr(1);

    if (hash == "" || hash == "#" || hash == window.prevhash)
    {
      window.prevhash = hash;
      return;
    }
    window.prevhash = hash;

    var instructions = hash.split("&");

    for(var idx = 0; idx < instructions.length; idx++)
    {
      var instruction = instructions[idx];
      if (instruction.substr(0,4) == "app=")
        this.executeInstruction({ type: "appmessage", app: instruction.substr(4), message: null, reuse_instance: false, target: {} });
    }

    window.location.hash = "#";
  }

, onDomReady:function()
  {
    $todd.towl = new TowlNotifications(this);

    if(WHBase.config.tollium.appserviceparams.uacode && window.ga)
    {
      window.ga('create', WHBase.config.tollium.appserviceparams.uacode, location.hostname, 'tollium');
      window.ga('tollium.send', 'pageview');
    }

    this.setScollbarStylingMode();

    // Prevent menus (especially an application's main menu) from opening off the right side of the screen
    MenuComponent.setOptions(
        { horizbounds: document.body
        , allowscrollableview: true
        });

    require("./tabs").setupfunction();

    this.continueLaunch();
  }

/****************************************************************************************************************************
 * External API
 */
, registerCustomAction:function(name,handler)
  {
    if($todd.customactions[name])
    {
      console.error("A handler for custom action '" + name + "' is already installed");
      return;
    }
    $todd.customactions[name]=handler;
  }

/****************************************************************************************************************************
 * Application management
 */

, startFrontendApplication:function(appname, parentapp, options)
  {
    var application = new $todd.FrontendEmbeddedApplication(this, appname, (options && options.target) || {}, parentapp, options);
    $todd.applications.push(application);

    if(!options || options.track != false)
      $todd.analyticsCommand('send', 'pageview', location.protocol + '//' + location.host + '/#frontendapp/' + appname);
    application.loadApplication({ src: options.src
                                , baseobject: appname
                                });
    if(!options.inbackground && !parentapp)
      application.activateApp();

    return application;
  }
, startBackendApplication: function(appname, parentapp, options)
  {
    if(appname == '__jsapp_hack__') //FIXME proper way to start JS frontend apps
    {
      this.startFrontendApplication('TestJSApp', parentapp, {src:'/tollium_todd.res/webhare_testsuite/tollium/jsapp.js'});
      return;
    }

    $todd.towl.hideNotification("tollium:shell.frontendclose");

    options = options || {};
    options.frontendid = WHBase.config.tollium.frontendid;
    options.shorttid = WHBase.config.tollium.shorttid;
    options.params = WHBase.config.tollium.appserviceparams;


    var application = new $todd.BackendApplication(this, appname, (options && options.target) || {}, parentapp, options);
    $todd.applications.push(application);

    if(!options || options.track != false)
      $todd.analyticsCommand('send', 'pageview', location.protocol + '//' + location.host + '/?app=' + appname);

    application.launchApp();
    if(!options.inbackground && !parentapp)
      application.activateApp();

    return application;
  }
, editPersonalSettings:function()
  {
    if(this.settings.personalsettings)
      this.executeInstruction(this.settings.personalsettings);
  }
, getApplicationById:function(id)
  {
    for(var i=0;i<$todd.applications.length;++i)
      if($todd.applications[i].whsid==id)
        return $todd.applications[i];
    return null;
  }

, registerApplicationFrontendLink: function(data)
  {
    // Register the frontend id
    var seenfrontend = $todd.frontendids.contains(data.frontendid);
    if(!seenfrontend)
      $todd.frontendids.push(data.frontendid);

    if(!seenfrontend) //FIXME should we register an endpoint if it wasn't an appstart? (what else could it be)? Decided to do it anyway, as the original code _did_ include the frontendid into $tdod.frontendids no matter what..
    {
      var metacomm = new $todd.LinkEndPoint({ linkid: data.linkid, commhost: data.commhost, frontendid: data.frontendid });
      metacomm.onmessage = this._gotMetaMessage.bind(this.shell);
      metacomm.onclosed = this._gotMetaClose.bind(this, data.frontendid);
      metacomm.register($todd.transportmgr);
    }
  }

/****************************************************************************************************************************
 * Component registration, creation and loading API
 */

  // If callback is not defined, loading new components is not allowed
  // Returns a list of unloaded components
, checkComponentsLoaded: function(compnames, callback)
  {
    var unloaded_components = [];
    compnames.each(function(item)
    {
      if (!todd_components[item] && !unloaded_components.contains(item))
        unloaded_components.push(item);
    }, this);

    if(unloaded_components.length > 0)
    {
      console.error("Unknown components: " + unloaded_components.join("; "));
    }
    return unloaded_components;
  }

, createComponent: function(type, parentcomp, data, replacingcomp)
  {
    if(todd_components[type])
      return new todd_components[type](parentcomp, data, replacingcomp);

    console.error('Unrecognized component type \'' + type + '\'');
    return null;
  }
/*
, loadExternalScripts: function(scriptpaths, oncomplete)
  {
    var scriptels=[];
    for (var i=0;i<scriptpaths.length;++i)
    {
      //ADDME: Original version had client-side 'loaded' checks, might be a bit more efficient ?
      var script = scriptpaths[i];
      var url;
      if (script.substring(0,2) == "//")
        url = script;
      else
        url = $todd.resourcebase + 'js/' + script;

      scriptels.push(new $wh.PreloadableScript(url));
    }
    new $wh.Preloader(scriptels, { onComplete: oncomplete });
  }
*/
, completeLogin:function(data, lock)
  {
    this.tolliumservice.request('CompleteLogin', [ data ],
      function(response) //onsuccess
      {
       location.reload(true);
      }.bind(this),
      function(err) //onfail
      {
        console.error(err);
        lock.release();
      });
  }

/****************************************************************************************************************************
 * Internal functions: framework bootup
 */
, continueLaunch:function()
  {
    this.tolliumservice = new JSONRPC(); //the shell will always talk back to the applicationportal that started it
    this.checkservice = new JSONRPC(); //separate RPC channel for checks, as they can take time and shouldn't block StartApplication

    $todd.dummyimage = new Element('img', {"src":"data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="});
    if(Browser.ie11)
      document.documentElement.classList.add('browser-ie11');

    $todd.UpdateDesktopDimensions();

    // Initialize global event handlers
    window.addEvent("resize", $todd.UpdateDesktopDimensions);
    window.addEvent("movingstart", this.onMovingUpdate.bind(this, true));
    window.addEvent("message", this._onWindowMessage.bind(this));
    window.addEvent("movingend", this.onMovingUpdate.bind(this, false));
    window.addEvent("unload", $todd.globalevents.OnUnload);
    window.addEventListener("selectstart", this.onSelectStart.bind(this));
    window.addEvent("contextmenu", this.onContextMenu.bind(this));
    this.addEvent("applicationstackchange", this.onApplicationStackChange.bind(this));
    this.addEvent("applicationended", this.onApplicationEnded.bind(this));

    document.addListener("dragover", $todd.globalevents.OnDragFiles);
    document.addListener("drop", $todd.globalevents.OnDropFiles);

  //    $todd.commmanager = new $todd.AppCommManagerNG();
    $todd.transportmgr = new $todd.TransportManager();
    $todd.transportmgr.addEvent("offline", this._gotOffline.bind(this));
    $todd.transportmgr.addEvent("online", this._gotOnline.bind(this));

    var appbar=$('t-apptabs');
    if(appbar)
      $todd.applicationBar = new $todd.ApplicationBar(this, appbar);

    window.fireEvent("toddready");
    $todd.registerJSApp('tollium:builtin.placeholder', PlaceholderApp);

    // Load the offline notification icon, so it can be shown when actually offline
    this.offlinenotificationicon = toddImages.createImage("tollium:messageboxes/warning", 24, 24, 'b');

    //Launch the Connect iframe
    this.connectiframe = new Element("iframe", { src: getWebHareConnectURL() + "shell/"
                                                    , class: "iframe--hidden"
                                                    });
    document.body.appendChild(this.connectiframe);
    this.executeShell();
  }
, executeShell:function()
  {
    //Launch a placeholder app, simply to get 'something' up and running fast, and display the loader (otherwise we'd have to hack a special loader for 'no-apps')
    this.startuplock = dompack.flagUIBusy();
    this.placeholderapp = this.startFrontendApplication('tollium:builtin.placeholder', null, { onappbar: false, track: false });

    console.log("launching StartPortal and the shell");

    //This is the true shell. Ask the tollium shell what we need to do. Pass it any webvariables?
    var options = {};
    options.params = WHBase.config.tollium.appserviceparams;
    this.tolliumservice.request('StartPortal', [ options, deviceinfo.getInfo() ], this.gotPortal.bind(this), this.failPortal.bind(this));
  }
, gotPortal:function(data)
  {
    this.versioninfo = data.version;
    this.isloggedin = data.isloggedin;
    document.documentElement.toggleClass("wh-wrdauth-loggedin", this.isloggedin); //we wish to switch to wh-wrdauth
    /// Ensure that we don't get a reboot instruction because of sessionStorage persistence:
    if(sessionStorage.getItem("WebHare-lastInitVersion-commit") != null || sessionStorage.getItem("WebHare-lastInitVersion-commit") != undefined)
      sessionStorage.removeItem("WebHare-lastInitVersion-commit");

    var wasjustupdated = sessionStorage.getItem("WebHare-lastInitVersion-updated");

    this.applyShellSettings(data.settings);

    if(!data.isloggedin)
    {
      this.loginapp = this.startFrontendApplication('tollium:builtin.login', null,
                              { onappbar:false
                              , src: '/.tollium/ui/js/login.js'
                              , onEnded: this.executeShell.bind(this)
                              , target: data.loginconfig
                              , track: false
                              });
      if(this.settings.loginbg != "")
      {
        var visible = document.querySelectorAll('.appcanvas.wh-focuszone.visible');
        if(visible.length>0)
          visible[0].setStyles({ "background-image": "url(" + this.settings.loginbg + ")"
                               , "background-size": "cover"
                               , "background-repeat": "no-repeat"
                              });
      }

      if(this.placeholderapp) //we can close it now
      {
        this.placeholderapp.terminateApplication();
        this.placeholderapp = null;
      }
      this.startuplock.release();
      return;
    }

    if(!this.dashboardapp && data.settings.dashboard)
      this.dashboardapp = this.startFrontendApplication('tollium:builtin.dashboard', null, { src: '/.tollium/ui/js/dashboard.js', fixedonappbar: true, track: false } );

    WHBase.config.tollium.initialinstructions.forEach(this.executeInstruction.bind(this));

    if(this.placeholderapp) //we can close it now
    {
      this.placeholderapp.terminateApplication();
      this.placeholderapp = null;
    }

    if(wasjustupdated)
    {
      sessionStorage.removeItem("WebHare-lastInitVersion-updated");
      var notification = { id: -987654321
                         , description: "This server was just updated to a new version, which necessitated all your application sessions to be terminated. We apologize for any inconvenience."
                         , timeout: 0
                         , icon: "tollium:messageboxes/information"
                         , title: "This server was just updated."
                         };

      $todd.towl.showNotification(notification);
    }
    this.startuplock.release();
  }
, failPortal:function(response)
  {
    console.log(response);
    this.startuplock.release();
    alert("Portal startup failed"); //FIXME nicely handle this
  }
, onApplicationStackChange:function()
  {
    //if not app is open, open something. not sure about the best approach, we'll just try to activate the last app on the tab bar (The most recently opened one)
    if(!$todd.getActiveApplication() && $todd.applicationBar.apps.length > 0)
      $todd.applicationBar.apps.getLast().app.activateApp();
  }
, onMovingUpdate:function(start, event)
  {
    document.documentElement.toggleClass("moveInProgress", start);
  }
, onApplicationEnded: function(app)
  {
    if(this.isloggingoff) //do not interfere with the normal closing of apps
      return;

    if($todd.applications.length == 0) //no dashboard and no way to open an app?
      if(this.settings.reloadonexit)
        location.reload();
      else
        window.close();
  }

, doLogoff:function()
  {
    this.isloggingoff = true; //prevent dashboard etc from playing during a logoff

    while($todd.applications.length)
      $todd.applications[0].terminateApplication();

    this.wrdauth.logout();
  }
, requestNewShellSettings:function()
  {
    var options = {};
    options.params = WHBase.config.tollium.appserviceparams;
    this.tolliumservice.request('GetCurrentShellSettings', [ options ], this.applyShellSettings.bind(this));
  }
, getCurrentSettings:function()
  {
    return this.settings;
  }
, applyShellSettings:function(settings)
  {
    this.settings = settings;

    if(settings.lang == 'nl')
      Locale.use("nl-NL");
    else
      Locale.use("en-US");

    this.eventsconnection.setGroups(settings.eventgroups);
    this.broadcaststart = Date.parse(settings.now);
    this.eventsconnection.start();
    $todd.towl.setNotificationLocation(settings.notificationslocation);

    var rev = this.settings.version.committag;
    var knownrev = sessionStorage.getItem("WebHare-lastInitVersion-commit");

    if(knownrev == undefined || knownrev == null || knownrev == "")
    {
      //We've never received a revision; let's see if we can set one:
      if(rev != "")
        sessionStorage.setItem("WebHare-lastInitVersion-commit", rev);
      else
        console.info("No committag available for this version. Assuming development build and ignoring versioning checks.");
    }
    else
    {
      if(knownrev != rev)
      {
        ///This is an updated WebHare version; use that info
        console.warn("The WebHare installation on this server has been updated since you started your session.");
        console.info("Your working version was loaded using", knownrev, "but the server now runs version", rev);
        sessionStorage.removeItem("WebHare-lastInitVersion-commit");
        sessionStorage.setItem("WebHare-lastInitVersion-updated", true);
        $shell.dashboardapp.activateApp();
        //var lock = $todd.applications[0].getBusyLock();
        //var modalitylayer = new $wh.PopupManager.ModalityLayer();
        $todd.createMessageBox( $todd.applications[0]
                              , { title: "Refresh required"
                                , text: "The WebHare installation on this server has been updated since you started your session.\nAll your application will be terminated and your browser will automatically refresh\nafter you close this dialog. We apologize for any inconvenience this may cause."
                                , buttons: [ { name: 'ok'
                                             , title: getTid("tollium:common.actions.ok")
                                             }
                                           ]
                                 , onclose: function(btnname){ window.location.reload(true); }
                                 });
      }
      else
      {
        ///This is basically for debugging
        //console.info("toddApplyShellSettings: Revision check successful, revision remains at", knownrev);
      }
    }

    this.fireEvent("settingschange", {target:this, settings: settings });
    if($('openinfo'))
    {
      $('openinfo').setStyle("display", settings.openinfo ? "block" : "none");
      $('openinfo').set('text',settings.openinfo);
    }

    var curapp = $todd.applicationstack.getLast();
    if (curapp)
      curapp.setAppTitle(curapp.title);

    if(settings.checkinterval && !this.checkinterval)
    {
      this.checkinterval = window.setInterval(this.onCheckInterval.bind(this), settings.checkinterval);
      this.onCheckInterval();
    }
    else if(this.checkinterval && !settings.checkinterval)
    {
      window.clearInterval(this.checkinterval);
      this.checkinterval = 0;
    }
  }
, sendApplicationMessage: function(app, target, message, reuse_instance, isfrontendapp, webvars, inbackground)
  {
    if($todd.IsDebugTypeEnabled('communication'))
      console.log('toddSendApplicationMessage: app:' + app + ' reuse:' + reuse_instance + ' target:' + JSON.stringify(target) + " message:" + JSON.stringify(message));

    if (typeof reuse_instance !== "string")
      reuse_instance = reuse_instance ? "always" : "never";

    //FIXME: Send actual mesage and data
    if (reuse_instance !== "never")
    {
      for (var i=0; i < $todd.applications.length;++i)
      {
        //console.log('Compare with ' + i + ' app:' + $todd.applications[i].appname + ' target:', $todd.applications[i].apptarget);

        if($todd.applications[i].appname == app && JSON.stringify($todd.applications[i].apptarget) == JSON.stringify(target))
        {
          //Found it!
          //console.log("Reuse application #" + i);

          if (reuse_instance === "always")
          {
            if (message)
              $todd.applications[i].queueEvent("$appmessage", { message: message, onlynonbusy: false }, false);
            $todd.applications[i].activateApp();
          }
          else // onlynonbusy
          {
            $todd.applications[i].queueEventAsync("$appmessage", { message: message || null, onlynonbusy: true }).then(reply =>
            {
              if (reply && reply.busy)
                this.startBackendApplication(app, null, { target: target, message: message, isfrontendapp: isfrontendapp, webvars:webvars, inbackground: inbackground });
              else
                $todd.applications[i].activateApp();
            });
          }
          return;
        }
      }
    }

    if (app == "tollium:builtin.oauth")
    {
      this.startFrontendApplication(app, null,
                              { onappbar: true
                              , src: '/.tollium/ui/js/oauth.js'
                              });
      return;
    }
    this.startBackendApplication(app, null, { target: target, message: message, isfrontendapp: isfrontendapp, webvars:webvars, inbackground: inbackground });
  }
, executeInstruction: function(instr)
  {
    if(instr.type=='appmessage')
    {
      //ADDME background flag is now missing with initial launches, but i think it should just be specified by caller
      this.sendApplicationMessage(instr.app, instr.target, instr.message, instr.reuse_instance, instr.isfrontendapp, instr.webvars, instr.inbackground);
      return;
    }

    if(instr.type=='windowopen')
    {
      window.open(instr.link,'_blank');
      return;
    }

    if(instr.type=='shell:reveal') //mount + open in finder
    {
      //Request credentials from the server, then pass them on to the toolkit
      this.tolliumservice.request('ExecuteAction', [{ type: 'getwebdavprivileges' }], function(data)
      {
        if(data.success)
        {
          var mounturl = location.href.split('?')[0].split('#')[0];
          if(mounturl.substr(-1) != '/')
            mounturl += '/';
          mounturl += 'webdav/';

          this._postToConnect({type:"reveal", folder:instr.folder, login: data.response.login, password: data.response.password, url: mounturl });
        }
      }.bind(this));

      return;
    }

    if (instr.type=="shell:resetimagecache")
    {
      toddImages.resetImageCache();
      return;
    }

    console.error("shell instruction", instr);
  }
, onBroadcastData:function(event)
  {
    //ADDME dedupe events, filter events launched before we started
    event.msgs.forEach(msg =>
    {
      var data = JSON.parse(msg.msg);
      $todd.DebugTypedLog("communication", "Received a broadcast", data);

      if(new Date(data.now) < this.broadcaststart)
        return;

      var event = new domevents.CustomEvent("tollium-shell:broadcast", { bubbles:true, cancelable: false, detail: data.message});
      document.documentElement.dispatchEvent(event);
    });
  }
, onBroadcast:function(event)
  {
    //this event fires if data is broadcasted
    switch (event.detail.type)
    {
      case "tollium:shell.refreshmenu":
      case "tollium:shell.refreshdashboard":
      {
        this.requestNewShellSettings();
        return;
      }
      case "tollium:shell.updatechecks":
      {
        this.onCheckInterval();
        return;
      }

      case "tollium:towl.event":
      {
        var notification = { id: event.detail.id
                           , description: event.detail.description
                           , timeout: event.detail.timeout || 0
                           };
        if (event.detail.icon)
          notification.icon = event.detail.icon;
        if (event.detail.title)
          notification.title = event.detail.title;
        if (event.detail.applicationmessage)
          notification.applicationmessage = event.detail.applicationmessage;

        $todd.towl.showNotification(notification);
        return;
      }
      case "tollium:towl.hideevent":
      {
        $todd.towl.hideNotification(event.detail.id);
        return;
      }
    }
  }

, _gotMetaMessage: function(data)
  {
    var app = $shell.getApplicationById(data.appid);
    if(!app)
    {
      console.warn("Received error message for app " +data.appid + " but cannot find it",data.errors);
      return;
    }
    app.handleMetaMessage(data);
  }

, _gotMetaClose: function(frontendid)
  {
    $todd.DebugTypedLog('communication', frontendid, 'connection closed');

    var openapps = false;
    $todd.applications.forEach(function(app)
    {
      // Do we have any (non-crashed) applications open? Close them now.
      if (app.frontendid === frontendid && !app.appisclosing)
      {
        app.handleMetaClose();
        openapps = true;
      }
    });

    $todd.frontendids.erase(frontendid);

    if (openapps)
    {
      var notification =
            { id: "tollium:shell.frontendclose"
            , icon: "tollium:messageboxes/warning"
            , title: getTid("tollium:shell.frontendclose")
            , description: getTid("tollium:shell.frontendclose_description")
            , timeout: 0
            , persistent: true
            };

      $todd.towl.showNotification(notification);
    }
  }

, onSelectStart: function(event)
  {
    var target = event.target.nodeType==3 ? event.target.parentNode : event.target;
    if(['input','textarea'].contains(target.get('tag')) || (['t-text'].contains(target.get('tag')) && target.hasClass('selectable')) || target.getParent("div.wh-rtd-editor"))
      return; //these are okay to select. MSIE needs these explicitly allowed
    $todd.DebugTypedLog('ui', "preventing selection on: ",event.target);
    event.preventDefault();
  }
, onContextMenu:function(event)
  {
    if (domui.isAllowNativeContextMenu(event))
      return;

    event.preventDefault();
    $todd.DebugTypedLog('ui', "preventing context menu on: ",event.target);
  }

  // FIXME: works, but is this the best place to do this?
, setScollbarStylingMode: function()
  {
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild (inner);

    document.body.appendChild (outer);

    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2)
      w2 = outer.clientWidth;

    document.body.removeChild (outer);

    //return (w1 - w2);
    // if the scrollbar takes no space it means the system/browser
    // shows the scrollbar as overlay (probably appearing upon mouseover and on scroll actions).
    // In this case we *don't* want to style the scrollbar, as this forces the browser to disable the scrollbar overlay mode.
    if (w1-w2 > 0)
      document.documentElement.classList.add("stylescrollbars");

    $todd.settings.scrollbar_width = w1-w2;
  }

, onCheckInterval:function()
  {
    if(this.checkcall)
      return; //still one pending, skip this call
    this.checkcall = this.checkservice.request('GetCheckResult', [], this.onCheckResponse.bind(this, true), this.onCheckResponse.bind(this, false));
  }
, onCheckResponse:function(success, response)
  {
    this.checkcall = null;
    if(!success)
    {
      console.error("FIXME: Report server unreachable");
    }
    else
    {
      if(!response.privileged)
        return; //we don't have access

      if(response.firstmessage)
      {
        var message =
              { appurl: "system:monitor(system:checks)"
              , apptarget: null
              , messagedata: { panel: "system:checks" }
              , reuse_instance: true
              };

        var messagetext = getTid("tollium:shell.checks.errors", response.numleft, response.firstmessage);

        var notification =
              { id: "system:checks"
              , icon: "tollium:messageboxes/warning"
              , title: domencoding.encodeValue(getTid("tollium:shell.checks.unresolvedissues"))
              , description: domencoding.encodeValue(messagetext)
              , timeout: 0
              , applicationmessage: message
              , persistent: true
              };
        $todd.towl.showNotification(notification);
      }
      else
      {
        $todd.towl.hideNotification("system:checks");
      }
    }
  }

, _gotOffline: function()
  {
//    console.warn("Went offline, showing notification");

    if (!this.offlinenotification)
    {
      var notification =
            { id: "tollium:shell.offline"
            , icon: this.offlinenotificationicon
            , title: getTid("tollium:shell.offline")
            , description: getTid("tollium:shell.offline_description")
            , timeout: 0
            , persistent: true
            };

      $todd.towl.showNotification(notification);
      this.offlinenotification = true;
    }
  }

, _gotOnline: function()
  {
//    console.warn(this.offlinenotification ? "Online again" : "Online");

    if (this.offlinenotification)
      $todd.towl.hideNotification("tollium:shell.offline");

    this.offlinenotification = false;
  }

, getWebHareConnectData:function()
  {
    return { version: this._connectversion, capabilities: this._connectcapabilities };
  }

, getWebHareConnectVersion:function()
  {
    return this._connectversion;
  }

, hasWebHareConnect:function()
  {
    return this._connectversion>0;
  }

  /** Returns a promise that resolves to the list of registered installations
      @return
      @cell return.url URL of installation
  */
, getWebhareConnectRegisteredInstallations: function()
  {
    return this._postConnectRequest({ type: "getregisteredinstallations" }, 500).then(function(r)
    {
      return r.registered_installations;
    });
  }

, _postToConnect:function(msg)
  {
    try
    {
      msg["WebHareConnect"] = { version: WebhareConnectVersion };
      this.connectiframe.contentWindow.postMessage(msg,"*"); //post to anyone, we should be able to trust whatever connect.webhare.com did
    }
    catch(e)
    {
      console.error("Message to WebHareConnect frame failed",e);
    }
  }

, _postRegistration: function()
  {
    var url = location.href.split("?")[0];
    this._postToConnect({ type: "register", url: url });
  }

, _postConnectRequest: function(msg, timeout)
  {
    var requestId = ++this._connectrequestcounter;

    return new Promise(function(resolve, reject)
    {
      msg.requestId = requestId;
      this._postToConnect(msg);

      this._connectrequests.push(
        { requestId: requestId
        , resolve: resolve
        });

      if (timeout)
      {
        setTimeout(function()
        {
          reject(new Error("Request has timed out"));
        }, timeout);
      }
    }.bind(this)).finally(
      function()
      {
        // Remove this request from the list of outstanding requests
        this._connectrequests = this._connectrequests.filter(function(i) { return i.requestId !== requestId; });
      }.bind(this)
    );
  }

, _onWindowMessage:function(msg)
  {
    if(msg.data.WebHareConnect && msg.data.WebHareConnect.isconnect && msg.source == this.connectiframe.contentWindow) //it's a toolkit message
    {
      if(!this._toolkitsource) //still waiting for a greeting
      {
        this._connectversion = msg.data.WebHareConnect.version;
        this.fireEvent("webhareconnectchange");
      }

      switch(msg.data.type)
      {
        case 'greeting':
        {
          console.info("Got greeting from WebHare Connect", msg.data);
          this._postRegistration();
          setInterval(this._postRegistration.bind(this), 5000); // Renew our registration every 5 seconds
          return; //ok
        }

        case 'capabilities':
        {
          console.info("Got capabilities update from WebHare Connect", msg.data);
          this._connectcapabilities = msg.data.capabilities;
          return; //ok
        }

        case 'errormessage':
          alert(msg.data.message);
          return;

        case 'response':
        {
          var req = this._connectrequests.find(function(i) { return i.requestId === msg.data.responseId; });
          if (req)
            req.resolve(msg.data);
        } break;

        default:
          console.error("Unhandled WebHareConnect message type '" + msg.data.type + "'", msg.data);
      }
    }
  }
  /// Open Webhare Connect in a named windows
, openWebhareConnectInWindow: function()
  {
    window.open(getWebHareConnectURL(), "webhare-connect");
  }
});


$todd.handleApplicationErrors = function(app,data)
{
  if(!data.errors.length)
  {
    //It's just telling us our parent app has terminated. ADDME if we get no errors, but there are still screens open, there's still an issue!
    app.terminateApplication();
    return;
  }

  console.log("Received error message for app",app,data);
  var messages = '';
  var trace = '\nTrace:\n';

  for (var i = 0; i < data.errors.length; ++i)
  {
    if (data.errors[i].message)
    {
      messages += data.errors[i].message + "\n";
      messages += "At " + data.errors[i].filename + "(" + data.errors[i].line + "," + data.errors[i].col + ")\n";
    }
    else
    {
      if (data.errors[i].async_origin)
        trace += data.errors[i].async_origin + "\n";
      trace += data.errors[i].filename + "(" + data.errors[i].line + "," + data.errors[i].col + ") " + data.errors[i].func + "\n";
    }
  }

  ++globalerrorcount;
  $todd.analyticsCommand('send', 'event', "apperror", app.appname, messages + trace, globalerrorcount);

  app.requireComponentTypes(['panel','button','action','textarea'], reportApplicationError.bind(null,app,data,messages,trace));
};

function reportApplicationError(app,data,messages,trace)
{
  //Set up a crash handler dialog
  var buttons = [ {item:"restartbutton"},{item:"closebutton"}];
  if(data.debugtimeout>0)
    buttons = [{"item":"debugbutton"}].concat(buttons);

  var crashdialog = app.createScreen(
    { frame:       { bodynode: 'root', specials: ['closeaction','debugaction','restartaction'], allowresize:true, allowclose:true, title: getTid("tollium:shell.errors.errordialogtitle") }
    , root:        { type: 'panel', lines: [{items: [ {item:"body"} ], height:'1pr' }
                                           ,{items: [ {item:"footer"} ]}
                                           ]
                   , height:'1pr'
                   }
    , body:        { type: 'panel', lines: [{items: [{item:"errortext"}], layout:'left'}
                                           ,{items: [{item:"errorlist"}], height:'1pr' }
                                           ]
                   , height: '1pr'
                   , spacers: { top:true, bottom:true, left:true, right:true }
                   , width:'1pr'
                   }
    , errortext:   { type: 'text', value: getTid("tollium:shell.errors.encounterederror") }
    , footer:      { type: 'panel'
                   , lines: [{items: buttons,layout:'right'}]
                   , spacers: { top:true, bottom:true, left:true, right:true }
                   , isfooter: true
                   , width:'1pr'
                   }
    , closebutton: { type: 'button', title: getTid("tollium:common.actions.close"), action: 'closeaction' }
    , closeaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
    , debugbutton: { type: 'button', title: getTid("tollium:shell.errors.debug"), action: 'debugaction' }
    , debugaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] }
    , restartbutton: { type: 'button', title: getTid("tollium:shell.errors.restart"), action: 'restartaction' }
    , restartaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] }
    , errorlist:   { type: 'textarea', enabled: false, value: messages + trace, minwidth:"90x", minheight:"24x", width:'1pr', height:'1pr' }
    });

  var result = { closed: false };

  //app.removeAllBusyLocks();
  crashdialog.setMessageHandler("frame", "close", closeAppAfterError.bind(null, app, result));
  crashdialog.setMessageHandler("closeaction", "execute", (data, callback) => closeAppAfterError(app, result, callback));
  crashdialog.setMessageHandler("debugaction", "execute", debugApp.bind(null, crashdialog, app, data));
  crashdialog.setMessageHandler("restartaction", "execute", restartApp.bind(null, crashdialog, app, data));

  // Disable debug option after timeout
  if (data.debugtimeout)
  {
    (function()
    {
      if (!result.closed)
      {
        let debugaction = crashdialog.getComponent("debugaction");
        if (debugaction)
        {
          debugaction.xml_enabled = false;
          crashdialog.actionEnabler();
        }
      }
    }).delay(data.debugtimeout);
  }
}

function closeAppAfterError(app, result,callback)
{
  result.closed = true;
  callback();
  app.terminateApplication();
}

function debugApp(crashdialog, app, data, x, ondone)
{
  crashdialog.getComponent("debugaction").xml_enabled = false;
  crashdialog.actionEnabler();

  $shell.sendApplicationMessage('system:debugger', null, { groupid: data.appid }, false);
  ondone();
}
function restartApp(crashdialog, app, data, x, ondone)
{
  console.log('action restartApp');
  crashdialog.getComponent("debugaction").xml_enabled = false;
  crashdialog.getComponent("restartaction").xml_enabled = false;
  crashdialog.actionEnabler();

  app.restart().then(ondone);
}

var PlaceholderApp = new Class(
{ initialize:function(appinterface, callback)
  {
    this.app = appinterface;
  }
});

window.$moo = moo; //simplifies debugging..

//The API we'll export to external applictions
window.$tollium =
{ version:1
, registerJSApp: $todd.registerJSApp
, componentsToMessages: $todd.componentsToMessages
};

module.exports = IndyShell;



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/shell.es